import State from "../State";
import { convertToNumberProperty, TNumberProperty } from "../../types/TNumberProperty";
import { convertToBooleanProperty, TBooleanProperty } from "../../types/TBooleanProperty";
import { convertToLocationProperty, TLocationProperty } from "../../types/TLocationProperty";
import { DeviceConfig } from "../../services/DeviceConfigService/DeviceConfig";

export default class EnvirotainerState extends State {
	public battery: TNumberProperty;
	public minTemp: TNumberProperty;
	public maxTemp: TNumberProperty;
	public setPointHigh: TNumberProperty;
	public insideTemperatureCalib01: TNumberProperty;
	public insideTemperatureCalib02: TNumberProperty;
	public ambientRelativeHumidity: TNumberProperty;
	public ambientTemperatureMax: TNumberProperty;
	public ambientTemperatureMin: TNumberProperty;
	public setPointLow: TNumberProperty;
	public insideTemperatureMin: TNumberProperty;
	public insideTemperatureMax: TNumberProperty;
	public insideTemperatureAvg: TNumberProperty;
	public insideHumidity: TNumberProperty;
	public cargoInside: TBooleanProperty;
	public chargingState: TBooleanProperty;
	public myKey: TBooleanProperty;
	public doorOpen: TBooleanProperty;
	public flightDetectActive: TBooleanProperty;
	public setTempRange: TNumberProperty;

	constructor(data?: any) {
		super(data);

		if (data) {
			const epoch = data["Epoch"];

			this.battery = convertToNumberProperty(data["battery"], epoch || data["battery:clock"]);
			this.minTemp = convertToNumberProperty(data["minTemp"], epoch || data["minTemp:clock"]);
			this.maxTemp = convertToNumberProperty(data["maxTemp"], epoch || data["maxTemp:clock"]);
			this.setPointHigh = convertToNumberProperty(data["setPointHigh"], epoch || data["setPointHigh:clock"]);
			this.insideTemperatureCalib01 = convertToNumberProperty(data["insideTemperatureCalib01"], epoch || data["insideTemperatureCalib01:clock"]);
			this.insideTemperatureCalib02 = convertToNumberProperty(data["insideTemperatureCalib02"], epoch || data["insideTemperatureCalib02:clock"]);
			this.ambientRelativeHumidity = convertToNumberProperty(data["ambientRelativeHumidity"], epoch || data["ambientRelativeHumidity:clock"]);
			this.ambientTemperatureMax = convertToNumberProperty(data["ambientTemperatureMax"], epoch || data["ambientTemperatureMax:clock"]);
			this.ambientTemperatureMin = convertToNumberProperty(data["ambientTemperatureMin"], epoch || data["ambientTemperatureMin:clock"]);
			this.setPointLow = convertToNumberProperty(data["setPointLow"], epoch || data["setPointLow:clock"]);
			this.insideTemperatureMin = convertToNumberProperty(data["insideTemperatureMin"], epoch || data["insideTemperatureMin:clock"]);
			this.insideTemperatureMax = convertToNumberProperty(data["insideTemperatureMax"], epoch || data["insideTemperatureMax:clock"]);
			this.insideTemperatureAvg = convertToNumberProperty(data["insideTemperatureAvg"], epoch || data["insideTemperatureAvg:clock"]);
			this.insideHumidity = convertToNumberProperty(data["insideHumidity"], epoch || data["insideHumidity:clock"]);
			this.cargoInside = convertToBooleanProperty(data["cargoInside"], epoch || data["cargoInside:clock"]);
			this.chargingState = convertToBooleanProperty(data["chargingState"], epoch || data["chargingState:clock"]);
			this.myKey = convertToBooleanProperty(data["myKey"], epoch || data["myKey:clock"]);
			this.doorOpen = convertToBooleanProperty(data["doorOpen"], epoch || data["doorOpen:clock"]);
			this.flightDetectActive = convertToBooleanProperty(data["flightDetectActive"], epoch || data["flightDetectActive:clock"]);

			this.calculateSetPoint();
		}
	}

	public update(data: any): void {
		super.update(data);
		const epoch = data["Epoch"];

		if (data["battery"]) {
			this.battery = convertToNumberProperty(data["battery"], epoch || data["battery:clock"]);
		}
		if (data["minTemp"]) {
			this.minTemp = convertToNumberProperty(data["minTemp"], epoch || data["minTemp:clock"]);
		}
		if (data["maxTemp"]) {
			this.maxTemp = convertToNumberProperty(data["maxTemp"], epoch || data["maxTemp:clock"]);
		}
		if (data["setPointHigh"]) {
			this.setPointHigh = convertToNumberProperty(data["setPointHigh"], epoch || data["setPointHigh:clock"]);
		}
		if (data["insideTemperatureCalib01"]) {
			this.insideTemperatureCalib01 = convertToNumberProperty(data["insideTemperatureCalib01"], epoch || data["insideTemperatureCalib01:clock"]);
		}
		if (data["insideTemperatureCalib02"]) {
			this.insideTemperatureCalib02 = convertToNumberProperty(data["insideTemperatureCalib02"], epoch || data["insideTemperatureCalib02:clock"]);
		}
		if (data["ambientRelativeHumidity"]) {
			this.ambientRelativeHumidity = convertToNumberProperty(data["ambientRelativeHumidity"], epoch || data["ambientRelativeHumidity:clock"]);
		}
		if (data["ambientTemperatureMax"]) {
			this.ambientTemperatureMax = convertToNumberProperty(data["ambientTemperatureMax"], epoch || data["ambientTemperatureMax:clock"]);
		}
		if (data["ambientTemperatureMin"]) {
			this.ambientTemperatureMin = convertToNumberProperty(data["ambientTemperatureMin"], epoch || data["ambientTemperatureMin:clock"]);
		}
		if (data["setPointLow"]) {
			this.setPointLow = convertToNumberProperty(data["setPointLow"], epoch || data["setPointLow:clock"]);
		}
		if (data["insideTemperatureMin"]) {
			this.insideTemperatureMin = convertToNumberProperty(data["insideTemperatureMin"], epoch || data["insideTemperatureMin:clock"]);
		}
		if (data["insideTemperatureMax"]) {
			this.insideTemperatureMax = convertToNumberProperty(data["insideTemperatureMax"], epoch || data["insideTemperatureMax:clock"]);
		}
		if (data["insideTemperatureAvg"]) {
			this.insideTemperatureAvg = convertToNumberProperty(data["insideTemperatureAvg"], epoch || data["insideTemperatureAvg:clock"]);
		}
		if (data["insideHumidity"]) {
			this.insideHumidity = convertToNumberProperty(data["insideHumidity"], epoch || data["insideHumidity:clock"]);
		}
		if (data["cargoInside"]) {
			this.cargoInside = convertToBooleanProperty(data["cargoInside"], epoch || data["cargoInside:clock"]);
		}
		if (data["chargingState"]) {
			this.chargingState = convertToBooleanProperty(data["chargingState"], epoch || data["chargingState:clock"]);
		}
		if (data["myKey"]) {
			this.myKey = convertToBooleanProperty(data["myKey"], epoch || data["myKey:clock"]);
		}
		if (data["doorOpen"]) {
			this.doorOpen = convertToBooleanProperty(data["doorOpen"], epoch || data["doorOpen:clock"]);
		}
		if (data["flightDetectActive"]) {
			this.flightDetectActive = convertToBooleanProperty(data["flightDetectActive"], epoch || data["flightDetectActive:clock"]);
		}
	}

	private calculateSetPoint() {
		if (this.setPointHigh && this.setPointLow) {
			this.setTempRange = {
				value: (this.setPointHigh.value + this.setPointLow.value) / 2,
				epoch: this.setPointHigh.epoch >= this.setPointLow.epoch ? this.setPointHigh.epoch : this.setPointLow.epoch,
			};
		}
	}

	public static parseHistory(data: any, sensor: string): TNumberProperty|TBooleanProperty|TLocationProperty {

		if (sensor === "location") {
			return convertToLocationProperty(data, data.epoch);
		}
		const config = DeviceConfig.getEnvirotainerAttributesConfig().get(sensor);
		if (!config) {
			return convertToNumberProperty(data.value, data.epoch);
		}
		if (config.type === "boolean") {
			return convertToBooleanProperty(data.value, data.epoch);
		}

		return convertToNumberProperty(data.value, data.epoch);


	}
}
